import React from 'react';
import {EXISTING_SCHEMA_ID} from "../../../services/errorcodes";
import {ConfirmationDialog} from "../../../common/Dialog";

export function SchemaExistsConfirmation(props: { error: any, schemaId: string, onConfirm: () => void, onCancel: () => void }) {
  let errorCode;
  if (props.error instanceof Array && props.error[0].code) {
    errorCode = props.error[0].code;
  } else if (props.error && props.error.code) {
    errorCode = props.error.code;
  }
  if (errorCode === EXISTING_SCHEMA_ID) {
    const message = `Schema ID "${props.schemaId}" already exists. Do you like to override?`;
    return <ConfirmationDialog
      message={message}
      onConfirm={props.onConfirm}
      onCancel={props.onCancel}/>
  }
  return null;
}
